<template>
    <div :style="backgroundStyle(item)">
        <login-in v-if="isAlonePage"
            :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityUrl="activityUrl">
        </login-in>
        <!--权益品1*1-->
        <div v-if="item.imgStyle === '1'">
            <!-- 权益品 -->
            <div v-if="item.pageType !== 'voucher'">
                <div v-for="(item1,index) in item.goodsList"
                    :key="index"
                    class="beneficial-item-large">
                    <div class="large-contain"
                        :style="getCardStyle(item1)">
                        <div class="price-contain">
                            <img class="main-img"
                                :src="item1.mainImg">
                        </div>
                        <div class="product-info">
                            <div class="product-title ellipsis-text">{{ item1.exchangeGoodsName }}</div>
                            <div class="receive-time ellipsis-text">{{ getProductRecTime(item1) }}</div>
                            <div class="btn-contain">
                                <!-- 未到领取时间，显示倒计时 -->
                                <themaicCountDown v-if="item1.recieveTime > 0 && item1.useStatus === '09'"
                                    class="large-contain-mask"
                                    :countColor="countColor"
                                    :blockColor="blockColor"
                                    :blockBackgroundColor="blockBackgroundColor"
                                    :time="item1.recieveTime"
                                    @timeDownFinished="timeDownFinished(index)"></themaicCountDown>
                                <div class="count"
                                    :style="wordsColorStyle(item1)">
                                    <span
                                        v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '1' && item1.balanceAmount > 99999">剩余99999+</span>
                                    <span
                                        v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '1' && item1.balanceAmount <= 99999 && item1.balanceAmount > 0">剩余：{{ item1.balanceAmount }}</span>
                                    <span
                                        v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '1' && item1.balanceAmount === 0">剩余：0</span>
                                    <span
                                        v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '2' && item1.balanceAmount >= 1 && item1.balanceAmount <= 100">数量较少</span>
                                    <span
                                        v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '2' && item1.balanceAmount > 100">数量充裕</span>
                                </div>
                                <div class="btn-user-vip">
                                    <div v-if="showRestrictTypeName(item, index) "
                                        class="user-vip">{{ item1.restrictTypeName }}
                                    </div>
                                    <!-- 所有状态 01立即领取 02已领取 05已使用 09暂不可领 10已过期 11已领完 13去使用 -->
                                    <div v-if="item1.useStatus === '01'">
                                        <!-- 立即领取 -->
                                        <div v-if="item1.isShow"
                                            class="get-btn"
                                            @click="receiveAward(item,index)">
                                            <img class="get-btn-img"
                                                :src="item1.receiveButtonImgUrl">
                                        </div>
                                        <!-- 不可领取 -->
                                        <div v-else
                                            class="not-received-btn margin-top-btn">
                                            <img class="not-received-btn-img"
                                                :src="item1.notReceiveButtonImgUrl">
                                        </div>
                                    </div>
                                    <!-- 已领取 -->
                                    <div v-if="item1.useStatus === '02'"
                                        class="received-btn">已领取</div>
                                    <!-- 已使用 -->
                                    <img v-if="item1.useStatus === '05'"
                                        class="coupon-received"
                                        src="static/runtime/images/magic/used.png">
                                    <!-- 暂不可领 -->
                                    <div v-if="item1.useStatus === '09' || item1.useStatus === '1502'"
                                        class="not-received-btn">
                                        <img class="not-received-btn-img"
                                            :src="item1.notReceiveButtonImgUrl">
                                    </div>
                                    <!-- 已过期 -->
                                    <img v-if="isShowExpiredTag(item1.useStatus)"
                                        class="coupon-received"
                                        src="static/runtime/images/magic/expired.png">
                                    <!-- 超过领取时间 -->
                                    <img v-if="item1.useStatus === '08'"
                                        class="coupon-received"
                                        src="static/runtime/images/magic/exceedReceiveTime.png">
                                    <!-- 已领完 -->
                                    <img v-if="item1.useStatus === '11'"
                                        class="coupon-received"
                                        src="static/runtime/images/magic/received.png">
                                    <!-- 去使用 -->
                                    <div v-if="item1.useStatus === '13'"
                                        class="get-btn"
                                        @click="toUseDetails(item,index)">
                                        <img class="get-btn-img"
                                            :src="item1.exchangeButtonImgUrl">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 微信代金券 -->
            <div v-else>
                <!-- 代金券 -->
                <div v-for="item1,index in item.goodsList"
                    :key="index"
                    class="large-contain-voucher"
                    :style="getCardStyle(item1)">
                    <div class="voucher-corner">
                        <img class="voucher-corner-img"
                            :src="item1.voucherCornerPic">
                    </div>
                    <div class="price-contain"
                        :class="mainImgStyle(item1)">
                        <img class="main-img"
                            :src="item1.mainImg">
                    </div>
                    <div class="production-info">
                        <div class="product-title ellipsis-text"
                            :class="couponNameStyle(item1)"> {{ item1.couponName }}</div>
                        <div class="receive-time ellipsis-text"
                            :class="couponNameStyle(item1)"> {{ getProductRecTime(item1) }}</div>
                        <div class="btn-contain">
                            <div class="count"
                                :style="wordsColorStyle(item1)">
                                <!-- 已领完和不可领取不展示剩余数量  -->
                                <span
                                    v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '1' && item1.balanceAmount > 99999">剩余99999+</span>
                                <span
                                    v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '1' && item1.balanceAmount <= 99999 && item1.balanceAmount > 0">剩余：{{ item1.balanceAmount }}</span>
                                <span
                                    v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '1' && item1.balanceAmount === 0">剩余：0</span>
                                <span
                                    v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '2' && item1.balanceAmount >= 1 && item1.balanceAmount <= 100">数量较少</span>
                                <span
                                    v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item1.useStatus)) && item1.showRemainingAmountWay === '2' && item1.balanceAmount > 100">数量充裕</span>
                            </div>
                            <div class="btn-user-vip">
                                <div v-if="item1.restrictType !== '0' && (['01','02','09','13','14'].includes(item1.useStatus))"
                                    class="user-vip">{{ item1.restrictTypeName }}</div>
                                <!-- 所有状态 01立即领取 02已领取 05已使用 09暂不可领 10已过期 11已领完 13去使用 14不可领取 -->
                                <div v-if="item1.useStatus === '01'">
                                    <!-- 立即领取 -->
                                    <div v-if="item1.isShow"
                                        class="get-btn"
                                        @click="receiveAward(item,index)">
                                        <img class="get-btn-img"
                                            :src="item1.receiveButtonImgUrl">
                                    </div>
                                    <!-- 不可领取 -->
                                    <div v-else
                                        class="get-btn">
                                        <img class="get-btn-img"
                                            :src="item1.notReceiveButtonImgUrl">
                                    </div>
                                </div>
                                <!-- 已领取 -->
                                <div v-if="item1.useStatus === '02'"
                                    class="received-btn">已领取</div>
                                <!-- 已使用 -->
                                <img v-if="item1.useStatus === '05'"
                                    class="coupon-received"
                                    src="static/runtime/images/magic/used.png">
                                <!-- 暂不可领 -->
                                <div v-if="item1.useStatus === '09' || item1.useStatus === '1502'"
                                    class="get-btn">
                                    <img class="get-btn-img"
                                        :src="item1.notReceiveButtonImgUrl">
                                </div>
                                <!-- 已过期 -->
                                <img v-if="isShowExpiredTag(item1.useStatus)"
                                    class="coupon-received"
                                    src="static/runtime/images/magic/expired.png">
                                <!-- 超过领取时间 -->
                                <img v-if="item1.useStatus === '08'"
                                    class="coupon-received"
                                    src="static/runtime/images/magic/exceedReceiveTime.png">
                                <!-- 已领完 -->
                                <img v-if="item1.useStatus === '11'"
                                    class="coupon-received"
                                    src="static/runtime/images/magic/received.png">
                                <!-- 去使用 -->
                                <div v-if="item1.useStatus === '13'"
                                    class="get-btn"
                                    @click="toUseDetails(item,index)">
                                    <img class="get-btn-img"
                                        :src="item1.exchangeButtonImgUrl">
                                </div>
                                <!-- 未到领取时间，显示倒计时 -->
                                <themaicCountDown v-if="item1.recieveTime > 0 && item1.useStatus === '09'"
                                    class="large-contain-mask"
                                    :countColor="countColor"
                                    :blockColor="blockColor"
                                    :blockBackgroundColor="blockBackgroundColor"
                                    :time="item1.recieveTime"
                                    @timeDownFinished="timeDownFinished(index)"></themaicCountDown>
                                <!-- 特定用户领取,不可领取 -->
                                <div v-if="item1.useStatus === '14'"
                                    style="display: flex;align-self: flex-end;">
                                    <div class="received-btn">不可领取</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--权益品1*2-->
        <div v-if="item.imgStyle === '2'"
            class="small">
            <div v-for="item2,index in item.goodsList"
                :key="index"
                class="beneficial-item-small"
                :style="getCardStyle(item2)">
                <div class="product-img">
                    <img class="main-img"
                        :src="item2.mainImg">
                    <!-- 已领完 -->
                    <img v-if="item2.useStatus === '11'"
                        class="coupon-received"
                        src="static/runtime/images/magic/received.png">
                    <!-- 已使用 -->
                    <img v-if="item2.useStatus === '05'"
                        class="coupon-received"
                        src="static/runtime/images/magic/used.png">
                    <!-- 已过期 -->
                    <img v-if="isShowExpiredTag(item2.useStatus)"
                        class="coupon-received"
                        src="static/runtime/images/magic/expired.png">
                    <!-- 超过领取时间 -->
                    <img v-if="item2.useStatus === '08'"
                        class="coupon-received"
                        src="static/runtime/images/magic/exceedReceiveTime.png">
                </div>
                <div class="product-title-small ellipsis-text">{{ item2.exchangeGoodsName }}</div>
                <div class="receive-time-small ellipsis-text">{{ getProductRecTime(item2) }}</div>
                <div class="btn-contain-small">
                    <div class="count"
                        :style="{'color': item2.wordsColor}">
                        <span
                            v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item2.useStatus)) && item2.showRemainingAmountWay === '1' && item2.balanceAmount > 99999">剩余99999+</span>
                        <span
                            v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item2.useStatus)) && item2.showRemainingAmountWay === '1' && item2.balanceAmount <= 99999 && item2.balanceAmount > 0">剩余：{{ item2.balanceAmount }}</span>
                        <span
                            v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item2.useStatus)) && item2.showRemainingAmountWay === '1' && item2.balanceAmount === 0">剩余：0</span>
                        <span
                            v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item2.useStatus)) && item2.showRemainingAmountWay === '2' && item2.balanceAmount >= 1 && item2.balanceAmount <= 100">数量较少</span>
                        <span
                            v-if="!([useStatus.used,useStatus.exceedRecTime,useStatus.exceedUseTime,useStatus.hasReceivedAll,useStatus.cannotReceived].includes(item2.useStatus)) && item2.showRemainingAmountWay === '2' && item2.balanceAmount > 100">数量充裕</span>
                    </div>
                    <div class="btn-user-vip-exchange">
                        <div v-if="showRestrictTypeName(item, index)"
                            class="user-vip">{{ item2.restrictTypeName }}</div>
                        <!-- 所有状态 01立即领取 02已领取 05已使用 09暂不可领 10已过期 11已领完 13去使用 -->
                        <div v-if="item2.useStatus === '01'">
                            <!-- 立即领取 -->
                            <div v-if="item2.isShow"
                                class="get-btn"
                                @click="receiveAward(item,index)">
                                <img class="get-btn-img"
                                    :src="item2.receiveButtonImgUrl">
                            </div>
                            <!-- 不可领取 -->
                            <div v-else
                                class="not-received-btn margin-top-btn">
                                <img class="not-received-btn-img"
                                    :src="item2.notReceiveButtonImgUrl">
                            </div>
                        </div>
                        <!-- 已领取 -->
                        <div v-if="item2.useStatus === '02'"
                            class="received-btn">已领取</div>

                        <!-- 暂不可领 -->
                        <div v-if="item2.useStatus === '09' || item2.useStatus === '1502'"
                            class="not-received-btn">
                            <img class="not-received-btn-img"
                                :src="item2.notReceiveButtonImgUrl">
                        </div>
                        <!-- 去使用 -->
                        <div v-if="item2.useStatus === '13'"
                            class="get-btn"
                            @click="toUseDetails(item,index)">
                            <img class="get-btn-img"
                                :src="item2.exchangeButtonImgUrl">
                        </div>
                    </div>
                    <!-- 未到领取时间，显示倒计时 -->
                    <themaicCountDown v-if="item2.recieveTime > 0 && item2.useStatus === '09'"
                        class="small-contain-mask"
                        :countColor="countColor"
                        :blockColor="blockColor"
                        :blockBackgroundColor="blockBackgroundColor"
                        :time="item2.recieveTime"
                        @timeDownFinished="timeDownFinished(index)"></themaicCountDown>
                </div>
            </div>
        </div>
        <!-- 实物权益品到店自提 -->
        <receiveAwardModal ref="receiveAwardModal"
            :activityUrl="activityUrl"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :drawType="drawType"
            :miniFlag="miniprogramFlag"
            @openKindAwardModal="openKindAwardModal"></receiveAwardModal>
        <!-- 虚拟权益品用户信息录入弹窗 -->
        <codeCancelAfterVerfication v-if="codeShow"
            :awardObj="awardObj"
            :goodsIndex="goodsIndex"
            :codeUrl="awardObj.writeOffCodeUrl"
            :writeOffCode="awardObj.writeOffCode"
            :extendConfigFlag="awardObj.extendConfigFlag"
            :activationCode="awardObj.activationCode"
            :effectiveStartTime="awardObj.effectiveStartTime"
            :effectiveEndTime="awardObj.effectiveEndTime"
            @closeEnd="closeEnd"
            @getExchangeGoodsToUrl="getExchangeGoodsToUrl"></codeCancelAfterVerfication>
        <!-- 虚拟权益品用户信息录入弹窗 -->
        <virtualOnlineAwardModal ref="virtualOnlineAwardModal"
            :awardObj="awardObj"
            :userInfoList="userInfoList"
            :userBase="userBase"
            :goodsIndex="goodsIndex"
            :isReceived="isReceived"
            @handleVirtualOnline="handleVirtualOnline(arguments)"
            @openVirtualAwardModal="openVirtualAwardModal"
            @getExchangeGoodsToUrl="getExchangeGoodsToUrl"></virtualOnlineAwardModal>
        <!-- 实物权益品用户信息录入 -->
        <kindAwardModal ref="kindAwardModal"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :referrFlag="userBase.referrFlag"
            @nextStep="nextStep"></kindAwardModal>
        <!-- 实物线上邮寄用户信息录入 -->
        <realOnlineMailingModal ref="realOnlineMailingModal"
            :awardObj="awardObj"
            :userBase="userBase"
            :goodsIndex="goodsIndex"
            @handleRealOnlineMailing="handleRealOnlineMailing(arguments)"
            @nextStep="nextStep"></realOnlineMailingModal>
        <!-- 活动暂停 -->
        <suspend-dialog v-if="backgroundType"
            :showDialog="activitySuspended"
            img="static/runtime/images/magic/signIn/sign-in-pause.png"
            text="活动已暂停"></suspend-dialog>
        <!-- 领取权益品、代金券的时候验证身份的弹框 -->
        <identityVerifyDialog :isShowIdentityDialog.sync="isShowIdentityDialog"
            :verifyTitle="cashCouponVerifyTitle"
            :activityUrl="activityUrl"
            :isShowCheckBtn="isShowCheckBtn"
            :activityCode="activityCode"
            :clickListId="elementParentObjId"
            :clickIndex="clickIndex"
            :pageSource="'thematicActivity'"
            :isClickNextPage="isClickNextPage"
            :loginType="loginType"
            :identityTypeList="identityTypeList"
            :clickElementObj="clickElementObj"
            :checkChannel="checkChannel"
            :receiveAward="receiveAward"
            :activityType="activityType"
            :guideUserId="guideUserId"
            :storeCode="storeCode"
            :activityName="activityName"></identityVerifyDialog>
        <!-- 抽奖对象配置，企微好友控制，企微导购弹窗 -->
        <qywx-guide-limit-modal ref="qywxGuideLimit"
            :activityType="ActivityType.thematicActivity"></qywx-guide-limit-modal>
        <!-- 抽奖对象配置，社群用户控制，社群活码弹窗 -->
        <community-user-limit-modal ref="communityUserLimit"
            :activityType="ActivityType.thematicActivity"
            :activityCode="activityCode"></community-user-limit-modal>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import kindAwardModal from '../dynamicAttr/modal/kindAwardModal.vue';
import receiveAwardModal from '../dynamicAttr/modal/receiveAwardModal.vue';
import themaicCountDown from '../themaicComponent/themaic-count-down.vue';
import codeCancelAfterVerfication from '../../../../components/modal/code-cancel-after-verification.vue';
import { Dialog, Toast } from 'vant';
import virtualOnlineAwardModal from '../dynamicAttr/modal/virtual-online.vue';
import realOnlineMailingModal from '../../../../components/modal/real-online-mailing-modal.vue';
import loginIn from '../dynamicAttr/modal/login-in.vue';
import {
  ExchangeGoodsType,
  CollectionType,
  PMLinkType,
  useStatus,
  CustomerGroup,
  CouponType,
  LoginType,
  EnableMessageNotifications,
  ActivityType,
  USER_RESTRICTIONS_FLAG,
  USER_LIMIT_STATUS,
} from '../../../../commons/commonVariables.js';
import { queryNeedNotifyAwardInfo } from '../../../../commons/commonJudgeIsNeedNotify.js';
import utils, { AllLoginTypeHandler } from '../../../../utils/comUtils.js';
import suspendDialog from '../../../../components/modal/suspend-dialog.vue';
import { jumpToPointsMall, getValidity, pointsMallLinkJudge, getGoodsList, userLimitHandler } from '../common-methods/utils';
import identityVerifyDialog from '../dynamicAttr/identityVerifyDialog.vue';
import qywxGuideLimitModal from '../dynamicAttr/modal/qywxGuideLimitModal.vue';
import communityUserLimitModal from '../dynamicAttr/modal/communityUserLimitModal.vue';

export default {
  components: {
    themaicCountDown,
    kindAwardModal,
    receiveAwardModal,
    codeCancelAfterVerfication,
    virtualOnlineAwardModal,
    realOnlineMailingModal,
    loginIn,
    suspendDialog,
    identityVerifyDialog,
    qywxGuideLimitModal,
    communityUserLimitModal,
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    miniprogramFlag: {
      type: Boolean,
      default: true,
    },
    enableMessageNotifications: {
      type: String,
      default: '',
    },
    mobileVerification: {
      type: String,
      default: '',
    },
    smallIndexExchangeGoods: {
      type: Number,
      default: null,
    },
    bigItemExchangeGoods: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activitySuspended: false,
      pageId: '',
      backgroundType: '',
      pageType: '',
      userUnionid: '',
      alipayUserId: '',
      countColor: '#FFFFFF',
      blockColor: '#000',
      blockBackgroundColor: '#FFFFFF',
      item: {},
      activityUrl: '', // 当前活动地址
      awardObj: {},
      goodsIndex: 0,
      userBase: {},
      isReceived: false,
      activityObj: {},
      drawType: 'initDraw',
      loginType: '',
      isLoginFlag: false, // 默认没有登录
      activityCode: '',
      userInfoList: [],
      codeShow: false,
      usedFlag: '',
      adminRegions: {}, //首页行政区域ID对象，入参获取奖品的时候接口
      isShowIdentityDialog: false, //是否展示优惠券或者代金券的身份验证弹框
      cashCouponVerifyTitle: '', //展示代金券的身份验证弹框的内容
      mobileVerificationRouter: '', //pc配置为图片而非背景时，h5点击图片做编程式跳转传过来的mobileVerification 值为新老用户
      identityType: '',
      identityTypeList: [], //多方认证返回身份list
      isShowCheckBtn: true, //是否展示去验证按钮
      clickIndex: null, //当前选中券的index
      isClickNextPage: 'false', //是否点击了下级页面
      elementParentObjId: '', //当前选中券的父对象的id
      clickElementObj: {}, //当前选中的券对象
      isAlonePage: false, // 是否为独立的页面
      checkChannel: null,
      useStatus: useStatus,
      activityType: '',
      guideUserId: '',
      storeCode: '',
      activityName: '',
      USER_RESTRICTIONS_FLAG: USER_RESTRICTIONS_FLAG,
      ActivityType: ActivityType,
    };
  },
  watch: {
    detail: {
      handler(val) {
        if (val) {
          this.item = val;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (this.$route.query.pageId && this.$route.query.activityCode) {
      // 图片楼层
      this.isAlonePage = true;
      this.pageType = this.$route.query.pageType;
      this.activityCode = this.$route.query.activityCode;
      this.backgroundType = this.$route.query.backgroundType;
      this.miniprogramFlag = this.$route.query.miniprogramFlag === 'true';
      this.pageId = this.$route.query.pageId;
      this.activityType = this.$route.query.ay;
      this.guideUserId = this.$route.query.GUID;
      this.storeCode = this.$route.query.SC;
      this.activityName = this.$route.query.activityName;
      this.mobileVerificationRouter = this.$route.query.mobileVerification;
      this.isClickNextPage = 'true';
      // 权益品/代金券
      if (this.pageType === 'exchangegoods') {
        document.title = '权益品领取列表';
      } else if (this.pageType === 'voucher') {
        document.title = '代金券领取列表';
      }

      this.userUnionid = sessionStorage.getItem('userUnionid') || '';
      this.alipayUserId = sessionStorage.getItem('alipayUserId') || '';
      this.handleListQuery();
    } else {
      // 背景楼层
      this.isAlonePage = false;
    }
    // 初始化用户信息
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    this.userBase = Object.assign({}, userInfo);
    this.loginType = sessionStorage.getItem('loginType') || '';
    this.activityCode = (this.$route.query && this.$route.query.activityCode) || '';
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + this.activityCode;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true';
    this.adminRegions = JSON.parse(sessionStorage.getItem('adminRegions')) || {};
    // // 芝麻身份 学生 医生 护士认证完身份后重新调用领权益品接口
    const isFirst = sessionStorage.getItem('isFirst') || 'true';
    if (this.bigItemExchangeGoods && this.bigItemExchangeGoods.id && isFirst === 'true') {
      sessionStorage.setItem('isFirst', 'false');
      this.receiveAward(this.bigItemExchangeGoods, Number(this.smallIndexExchangeGoods));
    }
  },
  methods: {
    // 是否显示过期标签
    isShowExpiredTag(status) {
      return [useStatus.exceedUseTime].includes(status);
    },
    handleListQuery() {
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/queryActivityProject',
        //如果为空，就传空参数，登陆类型为微信登陆但没有登陆时，unionId需要传空字符
        notFilterNull: true,
        params: {
          activityCode: this.activityCode,
          unionId: this.userUnionid,
          alipayUserId: this.alipayUserId,
          loginType: loginType,
        },
        success: (r) => {
          let { code, result } = r;
          if (code === 200 && result) {
            result.loginType = AllLoginTypeHandler(result.loginType);
            const { activityPageList = [], loginType, activityStatus } = result;
            this.loginType = loginType;
            activityPageList.forEach((ii, index) => {
              if (ii.pageType === this.pageType && ii.id === this.pageId) {
                this.item = activityPageList[index];
              }
            });
            // 权益品楼层和代金券楼层
            // 获取角标图片路径(代金券才有)
            if (result.activityConfig.voucherCornerPic) {
              const voucherCornerPic = JSON.parse(result.activityConfig.voucherCornerPic);
              this.item.voucherCornerPic = this.$utils.getImageUrl(voucherCornerPic.file || '');
            }
            this.$set(this.item, 'goodsList', getGoodsList(result, this.item));
            this.activitySuspended = activityStatus === '2';
            this.item.goodsList.forEach((el) => {
              this.showClaimNowButton(el);
            });
            const isClickNextPage = sessionStorage.getItem('isClickNextPage');
            if (isClickNextPage === 'true') {
              const index = sessionStorage.getItem('clickIndex');
              this.receiveAward(this.item, Number(index));
            }
          }
        },
      });
    },
    showClaimNowButton(el) {
      const mobileVerification = this.mobileVerification || this.mobileVerificationRouter;
      // 为新老用户，则判断身份是否符合，符合则显示立即领取，不符合则显示不可领取
      el.isShow = true;
      if ([CustomerGroup.newOldUser].includes(el.restrictType) && el.userAuthenticationValue !== mobileVerification) {
        el.isShow = false;
      }
    },
    // 展示XXX专享标签(仅权益品)
    showRestrictTypeName(item, index) {
      return (
        (item.goodsList[index].restrictType !== '0' ||
          (item.exchangeGoodsVOList && item.exchangeGoodsVOList[index].userRestrictionsFlag === USER_RESTRICTIONS_FLAG.YES)) &&
        ['01', '02', '09', '13'].includes(item.goodsList[index].useStatus)
      );
    },
    handleActivityInfo(val, index) {
      let arr = [];
      // 代金券 权益品
      if (val.pageType === 'exchangegoods' && val.activityPageRewardSettingList) {
        arr = arr.concat(val.activityPageRewardSettingList[index]);
      } else if (val.pageType === 'voucher' && val.activityPageRewardSettingList) {
        arr = arr.concat(val.activityPageRewardSettingList);
      }
      arr = arr.map((item) => ({
        exchangeGoodsType: item.goodsType, //0:虚拟,1:实物,2:优惠券,3:积分,4:代金券,5:赠品券
        collectionType: item.collectionType, //领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
        businessId: item.activityCode, //普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
        businessType: '7', //业务类型 12.签到  7.专题活动 9.大转盘
        goodsId: item.goodsId,
      }));
      return arr;
    },
    backgroundStyle(item) {
      const style = {};
      if (this.backgroundType === 'image') {
        style.backgroundColor = '#f8f8f8';
        style.height = '100vh';
        style.overflowY = 'auto';
      } else {
        if (item && item.filePath && item.backgroundType === 'image') {
          style.background = `url('+ ${item.filePath}+') no-repeat`;
        } else {
          style.backgroundColor = item.backgroundContent;
        }
      }
      return style;
    },
    getCardStyle(item) {
      const style = {};
      // 透明度修改
      if ([useStatus.used, useStatus.exceedUseTime, useStatus.hasReceivedAll, useStatus.exceedRecTime].includes(item.useStatus)) {
        style.opacity = 0.7;
      } else {
        style.opacity = 1;
      }
      return style;
    },
    containTagStyle(item) {
      // 已领完，置灰
      if (item.useStatus === '11') {
        return 'contain-tag-grey';
        // 特定用户领取 || 未到领取时间 透明度修改
      } else if (item.useStatus === '14' || (item.recieveTime > 0 && item.useStatus === '09')) {
        return 'contain-tag-opacity';
      }
    },
    mainImgStyle(item) {
      // 已领完 || 特定用户领取 || 未到领取时间图片 透明度修改
      if (['05', '11', '14'].includes(item.useStatus)) {
        return 'main-img-opacity';
      }
      if (item.recieveTime > 0 && item.useStatus === '09') {
        return 'main-img-opacity';
      }
    },
    couponNameStyle(item) {
      // 已领完 || 特定用户领取 || 未到领取时间图片 透明度修改
      if (['05', '10', '11', '14'].includes(item.useStatus)) {
        return 'coupon-name-opacity';
      }
      if (item.recieveTime > 0 && item.useStatus === '09') {
        return 'coupon-name-opacity';
      }
    },
    wordsColorStyle(item) {
      const style = {};
      // 未到领取时间图片 透明度修改
      if (item.recieveTime > 0 && item.useStatus === '09') {
        style.color = '#BFBFBF';
      } else {
        style.color = item.wordsColor;
      }
      return style;
    },
    // 立即领取
    async receiveAward(item, index) {
      if (!this.isLoginFlag) {
        this.$utils.tips.message('warning', '登录后参与活动哦！');
        return;
      }
      this.goodsIndex = index;
      // exchangeGoodsType 权益品类型, 0:虚拟,1:实物,2:优惠券,3:积分,4:代金券,5:赠品券
      // collectionType 领取类型 (1:线上邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:预约兑卡密(虚拟);4:门店免单); 5:货柜自取
      if (!this.userBase && !this.userBase.accessToken && !this.userBase.userToken) {
        Toast('请登录后再试');
        return;
      }

      if (item.pageType === CouponType.voucher) {
        this.checkChannel = 1;
        if (item.couponMainVOList[index].restrictType === CustomerGroup.multimodalVerification) {
          this.identityType = item.couponMainVOList[index].userAuthenticationValue; // 用户未验证过芝麻学生/教师/医护、微信学生、edu教育身份，去校验组件验证时的入参
          this.identityTypeList = this.identityType && this.identityType.split(',');
        }
        this.getVoucher(item, index);
      } else {
        if (
          this.loginType !== 'none' &&
          this.isLoginFlag &&
          item.exchangeGoodsVOList &&
          item.exchangeGoodsVOList[index].userRestrictionsFlag === USER_RESTRICTIONS_FLAG.YES
        ) {
          const continueFlag = await this.beforeReceiveUserValidation(item.exchangeGoodsVOList[index].exchangeGoodsCode, ActivityType.thematicActivity);
          if (!continueFlag) return;
        }
        this.checkChannel = 2;
        if (item.exchangeGoodsVOList[index].restrictType === CustomerGroup.multimodalVerification) {
          this.identityType = item.exchangeGoodsVOList[index].userAuthenticationValue; // 用户未验证过芝麻学生/教师/医护、微信学生、edu教育身份，去校验组件验证时的入参
          this.identityTypeList = this.identityType && this.identityType.split(',');
        }
        //虚拟权益品线上兑换
        if (item.exchangeGoodsVOList[index].collectionType === '1' && item.exchangeGoodsVOList[index].exchangeGoodsType === '0') {
          // 学生 医护 教师身份的权益品先做验证
          const resultFlag = await this.getResultFlag(item, index);
          if (!resultFlag) return;
          this.userInfoList = item.exchangeGoodsVOList[index].userInfoList || [];
          this.awardObj = item;
          this.isReceived = false;
          this.$refs.virtualOnlineAwardModal.openModel();
        } else if (item.exchangeGoodsVOList[index].collectionType === '1' && item.exchangeGoodsVOList[index].exchangeGoodsType === '1') {
          // 实物+线上邮寄 学生 医护 教师身份的权益品先做验证
          const resultFlag = await this.getResultFlag(item, index);
          if (!resultFlag) return;
          this.awardObj = item;
          this.$nextTick(() => {
            this.$refs.realOnlineMailingModal.openModel();
          });
        } else {
          // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销；4.赠品券
          // 以上三种类型用此方法打开中奖弹窗
          this.receiveAwardNow(item, index);
        }
      }
    },
    async getResultFlag(item, index) {
      if (item.exchangeGoodsVOList[index].restrictType === CustomerGroup.multimodalVerification) {
        const result = await this.checkAliPayAuthResult(item, index);
        return result;
      } else {
        return true;
      }
    },
    //虚拟权益品线上兑换 实物+线上邮寄先验证芝麻身份
    // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销 直接在领取权益品接口校验
    checkAliPayAuthResult(item, index) {
      const exchangeGoodsCode = item.exchangeGoodsVOList[index].exchangeGoodsCode;
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      return new Promise((resolve) => {
        this.$api.get({
          sc: 'mobileMarketing',
          url: `h5/projectActivity/activityProjectCheckAliPayAuthResult/${exchangeGoodsCode}/${loginType}`,
          params: {},
          success: (r) => {
            let flagResult = false;
            if (r && r.code === 200) {
              flagResult = true;
            } else if (r && r.code === 1501) {
              this.handleFirstError(item, index, r.message);
              flagResult = false;
            } else if (r && r.code === 1502) {
              this.handleSecondError(r.message);
              flagResult = false;
            } else {
              flagResult = false;
              Toast(r.message);
            }
            resolve(flagResult);
            sessionStorage.removeItem('isClickNextPage');
            sessionStorage.removeItem('clickIndex');
            sessionStorage.removeItem('clickListId');
          },
        });
      });
    },
    // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销
    // 以上三种类型用此方法打开中奖弹窗
    receiveAwardNow(item, index) {
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        nickName: this.userBase.nickName || '',
        exchangeGoodsId: item.exchangeGoodsVOList[index].id,
        exchangeGoodsCode: item.exchangeGoodsVOList[index].exchangeGoodsCode,
        exchangeGoodsName: item.exchangeGoodsVOList[index].exchangeGoodsName,
        exchangeGoodsType: item.exchangeGoodsVOList[index].exchangeGoodsType,
        awardType: 'exchangegoods',
        userHeadPortraitUrl: this.userBase.headimgurl,
        activityPageId: item.id,
        userRewardRegion: this.adminRegions,
        loginType: loginType,
      };
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/activityProjectReceiveAward',
        params: params,
        success: (r) => {
          if (r && r.code === 200 && r.result) {
            this.isVisibility = false;
            if (this.activityPausedHandler(r)) {
              // 改权益品楼层领取按钮状态 立即领取 ===》 去使用 （五种情况除了实物线上邮寄）
              item.goodsList[index].useStatus = '13';
              item.goodsList[index].balanceAmount -= 1;
              if (r.result.exchangeGoodsType && r.result.exchangeGoodsType !== '5') {
                item.goodsList[index].pickupStartTime = r.result.effectiveStartTime;
                item.goodsList[index].pickupEndTime = r.result.effectiveEndTime;
              }
              this.handleExchangeGoodsData(item, index, r.result, true);
            }
            // 领取权益品楼层埋码
            this.handleClickFloorProcess('exchangeGoods');
          } else {
            this.receiveFailedHandler(r, index, item);
          }
          sessionStorage.removeItem('isClickNextPage');
          sessionStorage.removeItem('clickIndex');
          sessionStorage.removeItem('clickListId');
        },
      });
    },
    /**
     * 领取权益品前置用户身份校验逻辑（企微、社群、入会）
     * @param {object} exchangeGoodsCode 权益品code
     * @param {String} activityType 活动类型
     */
    beforeReceiveUserValidation(exchangeGoodsCode, activityType) {
      const params = {
        exchangeGoodsCode: exchangeGoodsCode,
        activityCode: this.activityCode,
      };
      return new Promise((resolve) => {
        this.$api.post({
          sc: 'mobileMarketing',
          url: 'h5/projectActivity/checkExchangeGoodsCommunity',
          params: params,
          success: (r) => {
            if (
              r.code === 200 &&
              r.result &&
              [
                USER_LIMIT_STATUS.QY_WECHAT_GUIDE_TIME_LIMIT,
                USER_LIMIT_STATUS.COMMUNITY_USER_TIME_LIMIT,
                USER_LIMIT_STATUS.JOIN_MEMBER_TIME_LIMIT,
                USER_LIMIT_STATUS.NOT_ADD_QY_WECHA_GUIDE_LIMIT,
                USER_LIMIT_STATUS.NOT_ADD_COMMUNITY_LIMIT,
              ].includes(r.result.userLimitStatus)
            ) {
              userLimitHandler(r.result.userLimitStatus, activityType, r.result.userRestrictions, 'parent', this);
              resolve(false);
            } else {
              resolve(true);
            }
          },
          failure: (err) => {
            console.log('领取权益品前置用户身份校验查询失败', err);
            resolve(true);
          },
        });
      });
    },

    // 领取权益品、代金券失败处理
    receiveFailedHandler(r, index, item) {
      const msg = r.message ? r.message : '领取失败';
      // 权益品已过期，弹窗提示并修改状态为超过使用时间
      if (r.code === 501) {
        Dialog.alert({
          message: msg,
        }).then(() => {
          // 重新调接口
          if (this.$route.query.pageId) {
            this.handleListQuery();
          } else {
            this.$emit('initData');
          }
        });
      } else if (r.code === 1501) {
        // 1501 需要拉起授权
        this.handleFirstError(item, index, msg);
      } else if (r.code === 1502) {
        // 1502 认证不通过
        this.handleSecondError(msg);
      } else if (r.code === 1600) {
        userLimitHandler(r.result.userLimitStatus, ActivityType.thematicActivity, r.result.userRestrictions, 'parent', this);
      } else {
        // 场景1：1503 认证中
        Toast(msg);
      }
    },
    handleFirstError(item, index, msg) {
      this.isShowIdentityDialog = true;
      this.cashCouponVerifyTitle = msg;
      this.isShowCheckBtn = true;
      if (item.pageType) {
        if (item.pageType === CouponType.exchangegoods) {
          if (item.exchangeGoodsVOList[index].restrictType === CustomerGroup.multimodalVerification) {
            this.clickIndex = index;
            this.elementParentObjId = item.id;
            this.clickElementObj = item;
          }
        }
        if (item.pageType === CouponType.voucher) {
          if (item.couponMainVOList[index].restrictType === CustomerGroup.multimodalVerification) {
            this.clickIndex = index;
            this.elementParentObjId = item.id;
            this.clickElementObj = item;
          }
        }
      }
    },
    handleSecondError(msg) {
      this.isShowIdentityDialog = true;
      this.cashCouponVerifyTitle = msg;
      this.isShowCheckBtn = false;
    },

    // 处理三种权益品类型数据 + 打开弹窗
    // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销
    async handleExchangeGoodsData(item, index, result, receivedNow) {
      // 中奖弹框按钮样式写死
      this.activityObj.extendConfig = {
        awardPopupButtonColor: '',
      };
      item.writeOffCode = result.writeOffCode; //核销码
      item.writeOffCodeUrl = result.writeOffCodeUrl; //核销码url
      item.effectiveStartTime = result.effectiveStartTime; //有效开始日期
      item.effectiveEndTime = result.effectiveEndTime; //有效结束日期
      item.exchangeActivationCodeId = result.exchangeActivationCodeId; //预约导购code
      item.goodsId = result.exchangeGoodsId; // 权益品id
      item.collectionType = item.exchangeGoodsVOList[index].collectionType; // 领取类型
      item.goodsPictureUrl = item.exchangeGoodsVOList[index].activityGoodsImg; // 权益品图片
      item.rewardName = item.exchangeGoodsVOList[index].exchangeGoodsName; // 权益品名
      item.bigWheelActivityType = 1; // 由于中奖弹框背景图PC不配置,因此写死
      item.isBeneficial = true; // 从专题活动权益品楼层跳转到中奖弹框的标志
      item.usedFlag = result.usedFlag;
      item.activationCode = result.activationCode;
      if (item.exchangeGoodsVOList[index].isGuideFlag === '1') {
        item.appointmentFlag = '1'; //权益品配置需预约导购
      } else {
        // 不需要这个值的情况就要删掉
        delete item.appointmentFlag;
      }
      this.awardObj = item;
      let isNext = false;
      try {
        const params = {
          activityCode: result.activityCode,
          rewardRecodeId: (item.exchangeGoodsVOList[index] && item.exchangeGoodsVOList[index].rewardRecodeId) || result.rewardRecodeId || '',
          goodsId: result.exchangeGoodsId,
        };
        isNext = await getValidity(params, (item.exchangeGoodsVOList[index] && item.exchangeGoodsVOList[index].exchangeGoodsType) || '');
      } catch (err) {
        console.log(err);
      }

      setTimeout(() => {
        // 权益品配置了“需要预约导购”
        if (item.appointmentFlag === '1') {
          // 虚拟权益品 - 预约导购 - 线下核销、线下核销（发串码）
          if (
            item.exchangeGoodsVOList[index].exchangeGoodsType === ExchangeGoodsType.virtualAward &&
            (item.collectionType === CollectionType.inStore || item.collectionType === CollectionType.checkOffStrCode) &&
            isNext
          ) {
            this.toAppointmentGuide();
          } else if (
            // 实物权益品 - 预约导购 - 到店自提  或 赠品券 - 预约导购
            (item.exchangeGoodsVOList[index].exchangeGoodsType === ExchangeGoodsType.entityAward && item.collectionType === CollectionType.inStore && isNext) ||
            item.exchangeGoodsVOList[index].exchangeGoodsType === ExchangeGoodsType.giftCoupon
          ) {
            this.toAppointmentGuide();
          }
        } else {
          // 不需要预约导购
          // 实物权益品 - 到店自提 - 不需要预约导购
          if (isNext) {
            // 赠品券collectionType一直未null.赋值成2和虚拟线下核销用同一个弹框组件
            if (item.exchangeGoodsVOList[index].exchangeGoodsType === ExchangeGoodsType.giftCoupon) {
              this.awardObj.collectionType = CollectionType.inStore;
            }
            item.drawOrderSource = null; // 线下核销、预约兑卡密时,此时drawOrderSource=null,需要跳转预约导购
            this.codeShow = true;
            if (this.loginType === 'wechat' && this.enableMessageNotifications === '1') {
              let countDown = 1; //倒计时
              const timerId = setInterval(() => {
                if (countDown === 0) {
                  clearInterval(timerId);
                  if (this.codeShow && receivedNow) {
                    const params = this.handleActivityInfo(item, index);
                    queryNeedNotifyAwardInfo(params, this);
                  }
                } else {
                  countDown--;
                }
              }, 500);
            }
          }
        }
      }, 100);
    },
    //实物奖品录入完客户信息再打开实物奖品弹框
    openKindAwardModal() {
      this.$refs.receiveAwardModal.openModel();
    },
    //虚拟奖品录入完客户信息再打开虚拟奖品弹框
    openVirtualAwardModal() {
      this.$refs.virtualAwardModal.openModel();
    },

    //录入信息校验
    nextStep() {
      let self = this;
      if (self.nextActivityCode.indexOf('http') == -1 && self.nextActivityCode.indexOf('https') == -1 && self.nextActivityCode.indexOf('HD') > -1) {
        let path = '/hdmain?activityCode=' + self.nextActivityCode;
        self.$router.push({
          path: path,
        });
        self.$store.commit('base/setIsRouterAlive', false);
        self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
      } else {
        let currentOrigin = window.location.origin;
        if (self.nextActivityCode.indexOf(currentOrigin) > -1 && self.nextActivityCode.indexOf('hdmain') > -1) {
          let path = '/hdmain?' + self.nextActivityCode.split('?')[1];
          self.$router.push({
            path: path,
          });
          self.$store.commit('base/setIsRouterAlive', false);
          self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
        } else {
          window.location.href = self.nextActivityCode;
        }
      }
    },
    // 获取代金券接口
    getVoucher(item, index) {
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        nickName: this.userBase.nickName,
        stockId: item.couponMainVOList[index].stockId,
        awardType: 'voucher',
        userHeadPortraitUrl: this.userBase.headimgurl,
        activityPageId: item.id,
        userRewardRegion: this.adminRegions,
        loginType: loginType,
      };
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/activityProjectReceiveAward',
        params: params,
        success: (r) => {
          if (r && r.code === 200 && r.result) {
            if (this.activityPausedHandler(r)) {
              Toast('领取成功');
              console.log(r);
              console.log('领取成功');
              setTimeout(() => {
                item.goodsList[index].balanceAmount -= 1;
                item.goodsList[index].useStatus = '13';
                if (this.enableMessageNotifications === EnableMessageNotifications.open) {
                  //拉起订阅页面
                  const params = this.handleActivityInfo(item, index);
                  queryNeedNotifyAwardInfo(params, this);
                }
              }, 100);
              // 领取代金券楼层埋码
              this.handleClickFloorProcess('voucher');
            }
          } else {
            this.receiveFailedHandler(r, index, item);
          }
        },
      });
    },
    // 埋码时间：领取权益品楼层、代金券楼层
    handleClickFloorProcess(type) {
      let actionCode = '';
      let actionName = '';
      let title = '';
      switch (type) {
        // 1.权益品
        case 'exchangeGoods':
          {
            actionCode = '400060010';
            actionName = '权益品';
            title = '权益品';
          }
          break;
        // 2.代金券
        case 'voucher':
          {
            actionCode = '400060011';
            actionName = '代金券';
            title = '代金券';
          }
          break;
        default:
          console.log('埋码楼层类型不存在！');
      }
      const params = {
        actionCode: actionCode,
        actionName: actionName,
        content: {
          title: title,
          channel: this.loginType == 'none' ? '无需登陆' : this.loginType == 'wechat' ? '微信' : '支付宝',
          activityCode: this.activityCode,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      } else if (this.storeCode && this.guideUserId) {
        params.content.activityName = this.activityName;
        params.content.activityType = this.activityType;
        params.content.guideUserId = this.guideUserId;
        params.content.channelCode = this.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    //  获取权益品-页面跳转
    getExchangeGoodsToUrl(url) {
      // 链接为积分商城
      if (pointsMallLinkJudge(url) !== PMLinkType.notMatch) {
        jumpToPointsMall(this.activityCode, url);
        return;
      }
      if (this.loginType === 'wechat') {
        // 小程序环境
        if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
          // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
          const toUrl = url.split('webViewSrc=')[1];
          window.location.href = toUrl;
        } else if (url.indexOf('http') >= 0) {
          // 2.如果是http地址，就直接跳转
          window.location.href = url;
        } else if (url.indexOf('pages/tabBar/') >= 0) {
          // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
          wx.miniProgram.switchTab({
            url: url,
          });
        } else if (url.indexOf('subpackages') >= 0) {
          wx.miniProgram.navigateTo({
            url: url,
          });
        }
      } else if (this.loginType === 'Alipay') {
        if (this.miniprogramFlag) {
          // 支付宝小程序环境
          if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
            // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
            const toUrl = url.split('webViewSrc=')[1];
            window.location.href = toUrl;
          } else if (url.indexOf('http') >= 0) {
            // 2.如果是http地址，就直接跳转
            window.location.href = url;
          } else if (url.indexOf('pages/tabBar/') >= 0) {
            // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
            my.switchTab({
              url: url,
            });
          } else if (url.indexOf('subpackages') >= 0) {
            my.navigateTo({
              url: url,
            });
          }
        } else {
          // 支付宝H5环境
          const linkArr = url.split('?');
          let href = '';
          if (linkArr.length > 1) {
            if (linkArr[1].includes('skuCode') || linkArr[1].includes('spuCode')) {
              if (linkArr[0].includes('product-details-global')) {
                href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}&query=${encodeURIComponent(linkArr[1])}`;
              } else {
                href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}?${encodeURIComponent(linkArr[1])}`;
              }
            } else {
              href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}?${encodeURIComponent(linkArr[1])}`;
            }
          } else {
            href = `alipays://platformapi/startapp?appId=2021002121684220&page=${url}`;
          }

          window.location.href = href;
        }
      }
    },
    // 获取代金券后可能会有页面跳转
    getVoucherToUrl(url) {
      if (url) {
        // 链接为积分商城
        if (pointsMallLinkJudge(url) !== PMLinkType.notMatch) {
          jumpToPointsMall(this.activityCode, url);
          return;
        }
        const parentPageInfo = `&parentPage=thematicActivity&parentActivityCode=${this.activityCode}`;
        if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
          // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
          const toUrl = url.split('webViewSrc=')[1];
          window.location.href = toUrl + parentPageInfo;
        } else if (url.indexOf('http') >= 0) {
          // 2.如果是http地址，就直接跳转
          window.location.href = url + parentPageInfo;
        } else if (url.indexOf('pages/tabBar/') >= 0) {
          // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
          wx.miniProgram.switchTab({
            url: url,
          });
        } else if (url.indexOf('subpackages') >= 0) {
          wx.miniProgram.navigateTo({
            url: url,
          });
        } else {
          wx.miniProgram.navigateTo({
            url: '/subpackages/my/pages/couponList/coupon-list',
          });
        }
      } else {
        wx.miniProgram.navigateTo({
          url: '/subpackages/my/pages/couponList/coupon-list',
        });
      }
    },
    // 去使用-获取权益品详情
    toUseDetails(item, index) {
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        unionId: this.userBase.unionid,
        nickName: this.userBase.nickName || '',
        awardType: item.pageType,
        userHeadPortraitUrl: this.userBase.headimgurl,
        activityPageId: item.id,
      };
      this.goodsIndex = index;
      if (item.pageType === 'voucher') {
        // 权益品类型为代金券
        params.stockId = item.couponMainVOList[index].stockId;
      } else {
        // 权益品类型为实物/虚拟
        // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销 ；4.虚拟权益品线上兑换 ；5.实物 + 线上邮寄
        params.exchangeGoodsId = item.exchangeGoodsVOList[index].id;
        params.exchangeGoodsCode = item.exchangeGoodsVOList[index].exchangeGoodsCode;
        params.exchangeGoodsName = item.exchangeGoodsVOList[index].exchangeGoodsName;
        params.exchangeGoodsType = item.exchangeGoodsVOList[index].exchangeGoodsType;
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/awardRedemptionDetail',
        params: params,
        success: async (r) => {
          if (r.code === 200) {
            if (r.result) {
              let isNext = false;
              try {
                // 权益品楼层
                if (item.pageType !== 'voucher') {
                  // 虚拟权益品-线上兑换
                  if (
                    item.exchangeGoodsVOList[index].exchangeGoodsType === ExchangeGoodsType.virtualAward &&
                    item.exchangeGoodsVOList[index].collectionType === CollectionType.expressOrOnlineCheckOff
                  ) {
                    // 用户未领取卡密
                    if (!r.result.activationCode) {
                      const params = {
                        activityCode: r.result.activityCode,
                        rewardRecodeId: item.exchangeGoodsVOList[index].rewardRecodeId || r.result.rewardRecodeId || '',
                        goodsId: r.result.exchangeGoodsId,
                      };
                      isNext = await getValidity(params, item.exchangeGoodsVOList[index].exchangeGoodsType);
                    }
                  } else {
                    // 其他权益品
                    const params = {
                      activityCode: r.result.activityCode,
                      rewardRecodeId: item.exchangeGoodsVOList[index].rewardRecodeId || r.result.rewardRecodeId || '',
                      goodsId: r.result.exchangeGoodsId,
                    };
                    isNext = await getValidity(params, item.exchangeGoodsVOList[index].exchangeGoodsType);
                  }
                }
              } catch (err) {
                console.log(err);
              }
              setTimeout(() => {
                if (item.pageType === 'voucher') {
                  // 代金券去使用
                  this.getVoucherToUrl(r.result.voucherUrl);
                } else {
                  if (
                    item.exchangeGoodsVOList[index].collectionType === '1' &&
                    item.exchangeGoodsVOList[index].exchangeGoodsType === '0' &&
                    item.goodsList[index].useStatus === '13' &&
                    (isNext || r.result.activationCode)
                  ) {
                    // 虚拟-线上兑换-去使用
                    this.isReceived = true;
                    this.awardObj = r.result;
                    this.awardObj['jumpUrl'] = item.exchangeGoodsVOList[index].jumpUrl || '';
                    this.$refs.virtualOnlineAwardModal.openModel();
                  } else if (
                    item.exchangeGoodsVOList[index].collectionType === '1' &&
                    item.exchangeGoodsVOList[index].exchangeGoodsType === '1' &&
                    item.goodsList[index].useStatus === '02' &&
                    isNext
                  ) {
                    // 实物线上邮寄去使用
                    this.awardObj = r.result;
                    this.awardObj['jumpUrl'] = item.exchangeGoodsVOList[index].jumpUrl || '';
                    this.$refs.realOnlineMailingModal.modalCancel();
                    this.getExchangeGoodsToUrl(this.awardObj['jumpUrl']);
                  } else {
                    // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销
                    this.handleExchangeGoodsData(item, index, r.result, false);
                  }
                }
              }, 100);
            }
          } else {
            const msg = r.message ? r.message : '出错啦，请稍后再试';
            Toast(msg);
          }
        },
      });
    },
    handleVirtualOnline(msg) {
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      const item = msg[0];
      const index = msg[1];
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        nickName: this.userBase.nickName || '',
        exchangeGoodsId: item.exchangeGoodsVOList[index].id,
        exchangeGoodsCode: item.exchangeGoodsVOList[index].exchangeGoodsCode,
        exchangeGoodsName: item.exchangeGoodsVOList[index].exchangeGoodsName,
        exchangeGoodsType: item.exchangeGoodsVOList[index].exchangeGoodsType,
        awardType: 'exchangegoods',
        userHeadPortraitUrl: this.userBase.headimgurl,
        activityPageId: item.id,
        userRewardRegion: this.adminRegions,
        loginType: loginType,
      };
      if (this.userInfoList && this.userInfoList.length === 0) {
        (params.userName = msg[2]), (params.userPhone = msg[3]);
      } else {
        params.userInfoList = msg[2].userInfoList;
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/activityProjectReceiveAward',
        params: params,
        success: (r) => {
          if (r && r.code === 200 && r.result) {
            if (this.activityPausedHandler(r)) {
              Toast('领取成功');
              // 领取权益品楼层埋码
              this.handleClickFloorProcess('exchangeGoods');
              item.goodsList[index].useStatus = '13';
              item.goodsList[index].balanceAmount -= 1;
              item.goodsList[index].pickupStartTime = r.result.effectiveStartTime;
              item.goodsList[index].pickupEndTime = r.result.effectiveEndTime;
              this.$nextTick(() => {
                this.toUseDetails(item, index);
              });
            } else {
              this.$refs.virtualOnlineAwardModal.modalCancel();
            }
          } else {
            this.receiveFailedHandler(r, index);
          }
        },
      });
    },
    //实物线上邮寄
    handleRealOnlineMailing(msg) {
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      const item = msg[0];
      const index = msg[1];
      const info = msg[2];
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        nickName: this.userBase.nickName || '',
        exchangeGoodsId: item.exchangeGoodsVOList[index].id,
        exchangeGoodsCode: item.exchangeGoodsVOList[index].exchangeGoodsCode,
        exchangeGoodsName: item.exchangeGoodsVOList[index].exchangeGoodsName,
        exchangeGoodsType: item.exchangeGoodsVOList[index].exchangeGoodsType,
        awardType: 'exchangegoods',
        userHeadPortraitUrl: this.userBase.headimgurl,
        activityPageId: item.id,
        userName: info.userName,
        userPhone: info.userPhone,
        userAddress: info.userAddress,
        userCountryName: info.userCountryName,
        userProvinceName: info.userProvinceName,
        userCityName: info.userCityName,
        userZoneName: info.userZoneName,
        userRewardRegion: this.adminRegions,
        loginType: loginType,
      };
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/activityProjectReceiveAward',
        params: params,
        success: (r) => {
          if (r && r.code === 200 && r.result) {
            if (this.activityPausedHandler(r)) {
              Toast('领取成功');
              // 领取权益品楼层埋码
              this.handleClickFloorProcess('exchangeGoods');
              item.goodsList[index].useStatus = '02';
              item.goodsList[index].balanceAmount -= 1;
              item.goodsList[index].pickupStartTime = r.result.effectiveStartTime;
              item.goodsList[index].pickupEndTime = r.result.effectiveEndTime;
              this.$nextTick(() => {
                this.toUseDetails(item, index);
              });
            } else {
              this.$refs.realOnlineMailingModal.modalCancel();
            }
          } else {
            this.receiveFailedHandler(r, index);
          }
        },
      });
    },
    // 活动暂停处理
    activityPausedHandler(res) {
      if (res.result === 'ACTIVITY_IS_PAUSED') {
        if (this.backgroundType) {
          this.activitySuspended = true;
        } else {
          this.$emit('paused');
        }
        return false;
      } else {
        return true;
      }
    },
    timeDownFinished(index) {
      this.item.goodsList[index].useStatus = '01';
    },
    // 跳转预约导购
    async toAppointmentGuide() {
      const { result } = await this.checkShoppingGuide(this.awardObj.exchangeActivationCodeId);
      this.path =
        result && result.guideId
          ? `subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`
          : `subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${this.awardObj.exchangeActivationCodeId}&collectionType=${this.awardObj.collectionType}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`;
      let url = `/${this.path}`;
      const userBase = sessionStorage.getItem('userInfo');
      if (!userBase) {
        url += '&refresh=1';
      } else if (!userBase.member) {
        url += '&refresh=1';
      }
      sessionStorage.setItem('needRefreshPage', true);
      if (this.loginType === 'wechat') {
        wx.miniProgram.navigateTo({
          url: url,
          success: function () {
            console.log('跳转回小程序的页面success');
          },
          fail: function (res) {
            console.log('跳转回小程序的页面fail', res);
          },
        });
      } else {
        if (this.miniprogramFlag) {
          // 支付宝环境
          my.navigateTo({
            url: url,
          });
        } else {
          // 支付宝H5环境
          window.location.href = `alipays://platformapi/startapp?appId=2021002121684220&page=${url}`;
        }
      }
    },
    closeEnd() {
      this.codeShow = false;
    },
    //检测是否已经预约成功了
    checkShoppingGuide(id) {
      return new Promise((resolve, reject) => {
        this.$api.get({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    getProductRecTime(item) {
      if(item && item.pickupStartTime && item.pickupEndTime){
        return `${(item.pickupStartTime && item.pickupStartTime.split(' ')[0]) || ''} ~ ${(item.pickupEndTime && item.pickupEndTime.split(' ')[0]) || ''}`;
      }else{
        return ''
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.large-contain-voucher {
  width: 92vw;
  margin: 0 auto;
  height: 26.67vw;
  color: #cd9119;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  border-radius: 6px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  // 代金券角标
  .voucher-corner {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    height: 4vw;
    width: 10.9vw;
    .voucher-corner-img {
      width: 100%;
      height: 100%;
    }
  }
  .contain-tag {
    z-index: 1;
    padding: 0px 10px;
    position: absolute;
    top: 0;
    left: 0;
    height: 23px;
    font-family: HONORSansBrand-Regular;
    font-size: 12px;
    color: #644118;
    text-align: center;
    line-height: 23px;
    text-shadow: 0 2px 4px rgba(255, 234, 213, 0.86);
    font-weight: 400;
    background-image: -webkit-gradient(
      linear,
      right top,
      left top,
      from(#e8c48c),
      color-stop(41%, #f1d39f),
      color-stop(44%, #f2d4a1),
      color-stop(97%, #ffe7ba)
    );
    background-image: linear-gradient(270deg, #e8c48c 0%, #f1d39f 41%, #f2d4a1 44%, #ffe7ba 97%);
    border-radius: 8px 0 8px 0;
  }
  .contain-tag-grey {
    font-family: HONORSansBrand-Regular;
    font-size: 12px;
    color: #c3c3c3;
    text-align: center;
    line-height: 23px;
    text-shadow: 0 2px 4px rgba(255, 234, 213, 0.86);
    font-weight: 400;
    background-image: linear-gradient(243deg, #ebebeb 10%, #e8e8e8 100%);
    border-radius: 8px 0 8px 0;
  }
  .contain-tag-opacity {
    opacity: 0.5;
  }
  .price-contain {
    color: #a26e06;
    width: 20.7vw;
    height: 20.7vw;
    margin-left: 2.3vw;
    margin-right: 1.6vw;
    .main-img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }
  .main-img-opacity {
    opacity: 0.4;
  }
  .production-info {
    flex-grow: 1;
    max-width: 62.8vw;
  }
  .btn-contain {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .right-align {
      text-align: right;
    }
    .coupon-received {
      position: absolute;
      right: 0px;
      top: 0px;
      width: 16.4vw;
    }
    .coupon-name {
      font-size: 14px;
      color: #000000;
      font-weight: 500;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      word-break: break-all;
      filter: grayscale(50%);
    }
    .hide-text {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    .validity {
      font-family: HONORSansBrand-Regular;
      font-size: 12px;
      color: #999999;
      font-weight: 400;
    }
    .coupon-name-opacity {
      font-family: HONORSansBrand-Medium;
      color: #bfbfbf;
    }
    .received-btn {
      width: 19.733vw;
      height: 6.4vw;
      line-height: 6.4vw;
      border-radius: 6.933vw;
      background-color: #dddddd;
      color: #ffffff;
      align-self: flex-end;
      text-align: center;
    }
    .received-text {
      line-height: 24px;
      padding-right: 15px;
      color: #bfbfbf;
      -ms-flex-item-align: end;
      text-align: center;
    }
  }
  .large-contain-mask {
    height: 30.667vw;
    width: 100%;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0px;
    left: 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    z-index: 2;
    .use-btn {
      width: 21.333vw;
      height: 6.4vw;
      .use-btn-img {
        width: 100%;
        height: 100%;
      }
    }
    .use-out {
      height: 24px;
      line-height: 24px;
      padding-left: 15px;
      padding-right: 15px;
      border-radius: 24px;
      color: #ffffff;
    }
  }
}
.product-title {
  font-family: HONORSansBrand-Medium;
  font-size: 14px;
  color: #000000;
  line-height: 17px;
  font-weight: 500;
}
.receive-time {
  font-family: HONORSansBrand-Regular;
  font-size: 11px;
  color: #999999;
  line-height: 13px;
  font-weight: 400;
}
.count {
  font-size: 12px;
  font-weight: 400;
  padding-right: 10px;
  font-family: HONORSansBrand-Regular;
  color: #848484;
  letter-spacing: 0;
  line-height: 13px;
}
.btn-user-vip {
  display: flex;
  align-items: center;
  margin-top: 5px;
  .user-vip {
    margin-right: 6px;
    font-size: 12px;
    color: #848484;
    line-height: 13px;
    font-weight: 400;
  }
  .get-btn {
    width: 68px;
    height: 24px;
    .get-btn-img {
      width: 100%;
      height: 100%;
    }
  }
}

.beneficial-item-large {
  padding-bottom: 6px;
  padding-top: 6px;
  position: relative;
  .large-contain {
    background: #ffffff;
    border-radius: 6px;
    margin-bottom: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    width: 92vw;
    margin: 0 auto;
    height: 26.67vw;
    .price-contain {
      width: 20.67vw;
      height: 20.67vw;
      margin-left: 2.3vw;
      margin-right: 1.6vw;
      .main-img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      .use-condition {
        border: 1px solid red;
        height: 22px;
        line-height: 22px;
        width: 60%;
        border-radius: 22px;
        text-align: center;
        margin-top: 16px;
      }
      .beneficial-des {
        font-size: 16px;
        margin-top: 8px;
      }
    }
    .product-info {
      flex-grow: 1;
      padding-top: 5px;
      max-width: 62.8vw;
      height: 20.67vw;
    }
    .btn-contain {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .time {
        margin-top: 15px;
        display: flex;
        .time-bg {
          background-color: #e0e0e0;
          margin-left: 3px;
          margin-right: 3px;
          padding-left: 2px;
          padding-right: 2px;
          border-radius: 3px;
        }
      }
      .time-down {
        height: 30px;
      }

      .coupon-received {
        position: absolute;
        right: 20px;
        top: 5px;
        width: 16.4vw;
      }

      .received-btn {
        width: 74px;
        height: 24px;
        line-height: 24px;
        border-radius: 26px;
        margin-top: 5px;
        background-color: #dddddd;
        color: #ffffff;
        text-align: center;
      }
      .not-received-btn {
        width: 68px;
        height: 24px;
        margin-top: 1.333vw;
        .not-received-btn-img {
          width: 100%;
          height: 100%;
        }
      }
      .margin-top-btn {
        margin-top: 0;
      }
    }
  }
  .large-contain-mask {
    height: 26.67vw;
    width: 92%;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0px;
    left: 4%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    .use-btn {
      width: 21.333vw;
      height: 6.4vw;
      .use-btn-img {
        width: 100%;
        height: 100%;
      }
    }
    .use-out {
      height: 24px;
      line-height: 24px;
      padding-left: 15px;
      padding-right: 15px;
      border-radius: 24px;
      color: #ffffff;
    }
  }
}
.small {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 4vw;
  .beneficial-item-small {
    width: 44.7vw;
    height: 61.33vw;
    border-radius: 6px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    padding-top: 3.07vw;
    position: relative;
    margin-bottom: 10px;
    .product-img {
      flex-direction: column;
      height: 20.07vw;
      width: 20.07vw;
      margin: 0 auto;
      margin-bottom: 4.74vw;
      .main-img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      .coupon-received {
        position: absolute;
        width: 16.4vw;
        bottom: 0;
        right: 0;
      }
    }
    .product-title-small {
      font-family: HONORSansBrand-Medium;
      font-size: 14px;
      color: #000000;
      font-weight: 500;
      padding-left: 3.1vw;
      padding-right: 2.9vw;
      // 超出两行显示省略号
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 限制在两行 */
      -webkit-box-orient: vertical;
      line-height: 1.5; /* 调整行高 */
      max-height: 3em; /* 设置最大高度，这里假设行高为1.5，所以2行的高度是3em */
      white-space: normal;
      word-break: break-all;
    }
    .receive-time-small {
      font-family: HONORSansBrand-Regular;
      font-size: 11px;
      color: #999999;
      font-weight: 400;
      padding-left: 3.1vw;
      padding-right: 2.9vw;
      margin-bottom: 1.95vw;
    }
    .btn-contain-small {
      margin-left: 3.1vw;
      margin-right: 2.9vw;
      .time {
        margin-top: 5px;
        display: flex;
        .time-bg {
          background-color: #e0e0e0;
          margin-left: 3px;
          margin-right: 3px;
          padding-left: 2px;
          padding-right: 2px;
          border-radius: 3px;
        }
      }
      .time-down {
        height: 30px;
      }
      .count {
        font-family: HONORSansBrand-Regular;
        font-size: 12px;
        color: #848484;
        letter-spacing: 0;
        line-height: 13px;
        font-weight: 400;
        text-align: left;
      }
      .btn-user-vip-exchange {
        display: flex;
        align-items: center;
        margin-top: 5px;
        .user-vip {
          margin-right: 6px;
          font-size: 12px;
          color: #848484;
          line-height: 13px;
          font-weight: 400;
        }
        .get-btn {
          width: 68px;
          height: 24px;
          .get-btn-img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .received-btn {
        width: 74px;
        height: 24px;
        line-height: 26px;
        border-radius: 26px;
        margin-top: 2px;
        background-color: #dddddd;
        color: #ffffff;
        text-align: center;
      }
      .not-received-btn {
        width: 19.733vw;
        height: 6.4vw;
        margin-top: 0.533vw;
        .not-received-btn-img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .small-contain-mask {
      border-radius: 5px;
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      .use-btn {
        width: 21.333vw;
        height: 6.4vw;
        .use-btn-img {
          width: 100%;
          height: 100%;
        }
      }
      .use-out {
        height: 24px;
        line-height: 24px;
        padding-left: 15px;
        padding-right: 15px;
        border-radius: 24px;
        color: #ffffff;
      }
    }
  }
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* 保证不换行 */
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/beneficial-products.vue